var LogLevels;
(function (LogLevels) {
    LogLevels[LogLevels["silly"] = 0] = "silly";
    LogLevels[LogLevels["trace"] = 1] = "trace";
    LogLevels[LogLevels["debug"] = 2] = "debug";
    LogLevels[LogLevels["info"] = 3] = "info";
    LogLevels[LogLevels["warn"] = 4] = "warn";
    LogLevels[LogLevels["error"] = 5] = "error";
    LogLevels[LogLevels["fatal"] = 6] = "fatal";
})(LogLevels || (LogLevels = {}));
function getLogLevel() {
    if (process.env['REACT_APP_LOG_LEVEL'] === undefined)
        return LogLevels.info;
    const level = Number.parseInt(process.env['REACT_APP_LOG_LEVEL']);
    if (Number.isNaN(level))
        return LogLevels.info;
    return Math.max(Math.min(LogLevels.fatal, level), LogLevels.silly);
}
const LogLevel = getLogLevel();
export function log(...params) {
    if (LogLevel <= LogLevels.info)
        console.log(...params);
}
export function warn(...params) {
    if (LogLevel <= LogLevels.warn)
        console.warn(...params);
}
export function error(...params) {
    if (LogLevel <= LogLevels.error)
        console.error(...params);
}
export function fatal(...params) {
    if (LogLevel <= LogLevels.fatal)
        console.error(...params);
}
export function debug(...params) {
    if (LogLevel <= LogLevels.debug)
        console.debug(...params);
}
export function info(...params) {
    if (LogLevel <= LogLevels.info)
        console.info(...params);
}
export function trace(...params) {
    if (LogLevel <= LogLevels.trace)
        console.trace(...params);
}
export function silly(...params) {
    if (LogLevel <= LogLevels.silly)
        console.log(...params);
}
